"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = asPlainObjectOrThrow;
function asPlainObjectOrThrow(value, error) {
    if (!value || Array.isArray(value) || typeof value !== "object") {
        throw error;
    }
    return value;
}
//# sourceMappingURL=asPlainObjectOrThrow.js.map